import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { OnboardService } from "../shared/service/onboard-service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ThemeService } from "../theme";
import { UserService } from "../shared/service/user-service";
import { LocalStorageUtil } from "../shared/utils/local-storage/local-storage-util";
import { SnackBarUtil } from "../shared/utils/snackbar/snackbar-util";
import { SnackbarConstants } from "../constants/snackbar-constants";

@Component({
    selector: "zip-file-download-dialog.component",
    templateUrl: "./zip-file-download-dialog.component.html",
    styleUrls: ['./zip-file-download-dialog.component.scss'],

})
export class ZipFileDownloadDialog {
    isLoaderEnabled: boolean = false;
    loggedInOrgID: any;
    loggedInUserName: any;
    loggedInTenantID:any;
    downloadfiles = [];
    bulkdownloadItems = [];
    downloadWaiting = false;
  currentDisplayLanguage: string = 'en';


    constructor(private themeService: ThemeService, private userService: UserService,private snackBarUtil: SnackBarUtil, public snackBar: MatSnackBar, private onboardService: OnboardService, public dialogRef: MatDialogRef<ZipFileDownloadDialog>, @Inject(MAT_DIALOG_DATA) public data: any, private localStorageUtil: LocalStorageUtil) {
        //Rolebased Authorization
        if (this.localStorageUtil.isAccessTokenPresentAndValid()) {
            let accesstoken = this.localStorageUtil.getAccessToken();
            this.loggedInOrgID = accesstoken.loggedInOrgID;
            this.loggedInUserName = accesstoken.loggedInUsername;
        }
        this.currentDisplayLanguage = sessionStorage.getItem('currentlanguage');
        this.userService.changelanguage();
        this.userService.themesDatastring$.subscribe(e => {
            if (e != '' && e != ' ' && e != undefined && e != null && e != 'null') {
                this.themeService.setTheme(e);
            }
        });
    }


    ngOnInit() {
        this.downloadOrgbasedZipFiles();

    }
    onCancel(): void {
        this.dialogRef.close(null);
    }

    getTimeFromDate(createddate) {
        return new Date(createddate).toLocaleTimeString(navigator.language, { hour: '2-digit', minute: '2-digit' }).toString()

    }

    downloadOrgbasedZipFiles() {
        let data = {
            downloadtype: "bulkdownload",
            orgid: this.loggedInOrgID,
            username: this.loggedInUserName,
            tenantid: this.loggedInTenantID,
        }

        this.isLoaderEnabled = true;
        this.onboardService.onboardboardZipFileDownload(data).subscribe((response: any) => {
            if (response) {
                this.downloadfiles = response;
            }
            this.isLoaderEnabled = false;
        },
            error => {
                this.isLoaderEnabled = false
                this.snackBarUtil.triggerSnackBar(SnackbarConstants.ERROR_MESSAGE)
            })
    }

    convertBase64ToArrayBuffer(base64) {
        var binary_string = base64.replace(/\\n/g, '');
        binary_string = window.atob(base64);
        var len = binary_string.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes.buffer;
    }

    openFileEmptyDialog(message) {
        // let dialogRef = this.dialog.open(FileEmptyDialog, {
        //   data: message
        // });
        // dialogRef.afterClosed().subscribe(data => {
        // })
    }

    fileSettings(e) {
        let getItems = JSON.parse(this.localStorageUtil.getFileContents());
        this.bulkdownloadItems = getItems?.filter(item => (item.foldername) !== e['foldername']); // after download remove folder to array
        this.localStorageUtil.clearFileContents();
        this.localStorageUtil.setFileContents(JSON.stringify(this.bulkdownloadItems));
        this.downloadWaiting = false;
        if (this.bulkdownloadItems?.length > 0) {
            this.archieveDownload(this.bulkdownloadItems[0]);
        }
    }

    archieveDownload(e) {
        if (e.type === 'bulkdownload') {
            this.onboardService.archieveDownload(e['foldername']).subscribe((data: any) => {
                var a = document.createElement("a");
                if (data && data.fileContents) {
                    const blob = new Blob([this.convertBase64ToArrayBuffer(data.fileContents)], {
                        type: 'application/zip'
                    });
                    const url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = e.title;
                    a.click();
                    window.URL.revokeObjectURL(url);
                } else {
                    this.openFileEmptyDialog(e['title']);
                }
                this.fileSettings(e);

            }, error => {
                this.fileSettings(e);

            }
            );
        }
    }

}